import { render } from "./ItemPart.vue?vue&type=template&id=791ca987"
import script from "./ItemPart.vue?vue&type=script&lang=js"
export * from "./ItemPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__